var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVideoContent = function SvgVideoContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4467F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 18.448c0-1.5-1.212-2.716-2.708-2.716H12.705a2.712 2.712 0 0 0-2.708 2.716v8.145c0 1.5 1.213 2.716 2.708 2.716h12.187a2.712 2.712 0 0 0 2.709-2.716v-8.145Z",
    fill: "#fff",
    fillOpacity: 0.8,
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.955 11.66a2.712 2.712 0 0 1 2.708 2.715v8.146c0 1.5-1.212 2.715-2.708 2.715H16.768a2.712 2.712 0 0 1-2.708-2.715v-8.146c0-1.5 1.212-2.715 2.708-2.715h12.187Zm-3.665 6.223a.71.71 0 0 1 0 1.13 13.485 13.485 0 0 1-3.73 2.02l-.245.086a.78.78 0 0 1-1.029-.63 15.701 15.701 0 0 1 0-4.082.78.78 0 0 1 1.03-.63l.245.087a13.485 13.485 0 0 1 3.729 2.019Z",
    fill: "#fff",
    fillOpacity: 0.8
  })));
};

export default SvgVideoContent;